module.exports = __webpack_public_path__ + "static/img/多云.414dcedd.svg";